<template>
  <div>

        <div class="row text-center justify-content-center">
            <h2 class="form-title px-5">{{ data.name }}<span class="text-info" style="color:#00A0C1"> ({{ data.version }})</span></h2>
        </div>

        <hr>

        <div class="row text-center justify-content-center mb-2">
          <h6 style="color:#435666;">Last Modified: <strong>{{ formatDate(data.UpdatedAt) }}</strong></h6>
        </div>

        <form ref="policyFormRef" class="row g-0" style="gap: 0.5rem" @submit.prevent="">
          <div>
            <label for="lastName">Policy Name</label>
            <input type="text" id="lastName" v-model.trim="trainingPolicy.name" @blur="v$.trainingPolicy.name.$touch"
                class="form-control" placeholder="Name" />

            <span class="form-text text-danger" v-if="v$.trainingPolicy.name.$error">
                Name is required.
            </span>
          </div>

            <PolicyGroupSelector
              :groups="groups"
              :initial-group-id="trainingPolicy.policy_group_id"
              @group-selected="handleGroupSelection"
              @group-created="handleGroupSelection"
              @create-group-request="$emit('create-group-request', $event)"
              :can-create-group="canCreateGroup"
            />

          <div class="d-row d-flex" style="gap: 1rem">

            <div class="w-50">
              <label for="status">Status</label>
              <br>
              <span style="cursor:pointer;" @click="reviewPolicy" class="badge policy-badge" :class="'policy--'+trainingPolicy.status.toLowerCase()">{{ formatStatus(trainingPolicy.status) }}</span>
            </div>

            <div class="w-50">
              <label for="nextReviewDate">Policy Owner</label>
              <select class="form-select table-select shadow-none" v-model="trainingPolicy.owner" tabindex="-1"
              style="max-width: 300px !important;">
                <option v-for="user in users" :key="user.id" :value="user.id">{{ user.first_name + " " + user.last_name }}</option>
              </select>
            </div>

          </div>

        <div class="d-row d-flex" style="gap: 1rem">

          <div class="w-50">
            <label for="dateUploaded">Date Uploaded</label>
            <input type="text" id="dateUploaded"
            class="form-control" disabled :value="dateUploaded"/>
          </div>

          <div class="w-50">
            <label for="dateUploaded">Review Date</label>
            <input type="text" id="dateUploaded"
            class="form-control" disabled :value="formattedReviewDate"/>
          </div>

        </div>

        <div class="g-0 d-row d-flex flex-wrap flex-md-nowrap" style="gap: 0.5rem">

          <div class="w-50 vw-100">
            <label for="attestationRequired" class="form-label">Attestation Required</label>
            <select class="form-select" id="attestationRequired" v-model="trainingPolicy.compulsory">
              <option v-for="attestationRequirement in attestationRequirements" :key="attestationRequirement.value" :value="attestationRequirement.value">
                {{ attestationRequirement.label }}
              </option>
            </select>
          </div>

          <div class="w-50 vw-100">
            <label for="videoIdSelect" class="form-label">Training Video Link</label>
            <select class="form-select" id="videoIdSelect" v-model="trainingPolicy.videoID">
              <option selected disabled value>Please choose...</option>
              <option v-for="videoOption in videoIDs" :key="videoOption.value" :value="videoOption.value">
                {{ videoOption.label }}
              </option>
            </select>
          </div>

        </div>

        <div class="pt-3 pb-3 justify-content-center d-flex mt-5" style="gap:0.5rem">
          <!-- Cancel button is hidden when no changes have been made -->
          <button type="button" class="btn btn-outline-warning" @click="cancelEdit()"
            v-if="isModified">Cancel Changes</button>

          <!-- Save button is disabled when no changes have been made -->
          <button type="button" class="btn btn-info text-light" @click="validateForm()"
            :disabled="!isModified">Save</button>
        </div>

        <PolicyVersion ref="policyVersionRef" :data="data" @preview-version="handlePreview" />

      </form>



      </div>
</template>

<script>
import moment from 'moment';
import { Offcanvas } from 'bootstrap';
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import PolicyGroupSelector from './PolicyGroupSelector.vue';
import PolicyVersion from './PolicyVersion.vue';


export default{

  components: {
    PolicyGroupSelector,
    PolicyVersion,
  },

  props: {
    videoIDs: {
      type: Object,
      required: true,
      default: null,
    },
    data: {
      type: Object,
      required: false,
    },
    users: {
      type: Object,
      required: false,
    },
    groups: { type: Array, required: true },
  },

  emits: ['create-group-request', 'onUpdate', 'onClickReview', 'onCancel', 'onCancelRevert'],

  setup () {
    return { v$: useVuelidate() }
  },

  validations() {
      return {
        trainingPolicy: {
          name: { required },
         },
      }
   },

  data() {
    return {
      isInitialized: false,
      beforeEditingCache: {},
      trainingPolicy: {
        id: 0,
        name: '',
        link: '',
        compulsory: false,
        version: '',
        videoID: '',
        object: '',
        type: 'link',
        file: '',
        currLink: '',
        status: '',
        owner: 0,
        created_at: 0,
        review_date: 0,
        date_uploaded: 0,
        policy_group_id: null,
      },
      buttonLbl: "Create",
      attestationRequirements: [
        {label:"Yes",value:true},
        {label:"No",value:false}
      ],
    };
  },

  mounted() {
    this.initializeState(this.data);
  },

  watch: {
    data: {
      handler: 'initializeState',
      deep: true
    },
    groups(newGroups, oldGroups) {
      // If a new group was added while the form is open
      if (this.isInitialized && newGroups.length > oldGroups.length) {
        // Find the group that exists in the new list but not the old one
        const addedGroup = newGroups.find(ng => !oldGroups.some(og => og.ID === ng.ID));
        if (addedGroup) {
          this.handleGroupSelection(addedGroup);
        }
      }
    }
  },

  methods: {

    handlePreview(version) {
      // Use the 'link' or 'file_path' from your API response
      let urlToOpen = version.link || version.file_path || version.file_url;

      if (urlToOpen) {
        if (!urlToOpen.startsWith('http://') && !urlToOpen.startsWith('https://')) {
          urlToOpen = 'https://' + urlToOpen;
        }
        window.open(urlToOpen, '_blank');
      } else {
        console.warn('No link or file path found on this version object:', version);
      }
    },

    handleGroupSelection(selectedGroup) {
      this.trainingPolicy.policy_group_id = selectedGroup ? selectedGroup.ID : null;
    },

    initializeState(data) {
      if (!data) {
        return;
      }

      // Always update the working copy
      this.trainingPolicy.id = data.ID;
      this.trainingPolicy.name = data.name;
      this.trainingPolicy.currLink = data.link;
      this.trainingPolicy.link = data.link;
      this.trainingPolicy.file = data.link;
      this.trainingPolicy.compulsory = data.required;
      this.trainingPolicy.version = data.version;
      this.trainingPolicy.owner = data.owner;
      this.trainingPolicy.status = data.status;
      this.trainingPolicy.created_at = data.CreatedAt;
      this.trainingPolicy.date_uploaded = data.date_uploaded;
      this.trainingPolicy.review_date = data.review_date;
      this.trainingPolicy.policy_group_id = data.policy_group_id;
      this.buttonLbl = "Update";

      if (data.training_videos && data.training_videos.length !== 0) {
        this.trainingPolicy.videoID = data.training_videos[0].ID;
      }
      // Only set the "before" cache once when the form is first initialized
      if (!this.isInitialized) {
        this.beforeEditingCache = JSON.parse(JSON.stringify(this.trainingPolicy));
        this.isInitialized = true;
      }
    },
    resetComponentState() {
      this.isInitialized = false;
      this.beforeEditingCache = {};
    },
    fileHandler(files){

      if (files.files.length != undefined)
      {
        this.trainingPolicy.object = ''
        this.trainingPolicy.file = ''
      } else {
        this.trainingPolicy.object = files;
        this.trainingPolicy.file = files;
      }
    },

    // Method to show the offcanvas
    showOffcanvas() {
      const offcanvasInstance = new Offcanvas(this.$refs.offcanvasRight);
      offcanvasInstance.show();
    },

    async updatePolicy() {
      this.$emit("onUpdate", { data: this.trainingPolicy });
      this.state = false;
    },

    reviewPolicy(){
      this.$emit("onClickReview", { data: this.trainingPolicy });
      this.state = false;
    },

    truncatedLink(link) {
      const maxLength = 50;


      let truncated = link.substring(0, maxLength);
      if (link.length > maxLength) {
        truncated += '...';
      }

      return truncated;
    },

    closeDialog() {
      this.$emit("close");
      this.state = false;
    },

    cancelEdit() {
      // Return the data back to it’s previous state
      this.trainingPolicy = JSON.parse(JSON.stringify(this.beforeEditingCache));
      this.$emit('onCancelRevert');
    },

    disableFormButton() {
      const commonConditions = this.v$.$invalid || this.v$.$error || this.trainingPolicy.name == '';

      if ((this.trainingPolicy.type === 'file' && this.trainingPolicy.file == '') ||
          (this.trainingPolicy.type === 'link' && this.trainingPolicy.link == '') ||
          commonConditions) {
        return true;
      }

      return false;
    },

    switchType(newType) {
      this.trainingPolicy.type = newType;

      if (this.trainingPolicy.type === 'link') {
        this.trainingPolicy.file = this.trainingPolicy.link || '';
      } else if (this.trainingPolicy.type === 'file') {
        this.trainingPolicy.file = this.trainingPolicy.object || '';
      }

    },

    formatDate(utcDate) {
      return moment.utc(utcDate).local().format('D-MMM-YYYY');
    },

    formatStatus(status) {
      if (status == "current")
        return "Current"
      else if (status == "review_required")
        return "Review Required"
      else if (status == "review_overdue")
        return "Review Overdue"
    },

    async validateForm() {
      const isFormCorrect = await this.v$.$validate()
      if (isFormCorrect) {
        this.updatePolicy()
      }
    },
  },

  computed: {
    dateUploaded() {
      return this.formatDate(this.trainingPolicy.date_uploaded);
    },
    formattedReviewDate() {
      if (this.trainingPolicy.review_date == null) {
        return ""
      }

      return this.formatDate(this.trainingPolicy.review_date);
    },

    isModified() {
      // Compare the current policy to the cached version
      return JSON.stringify(this.trainingPolicy) !== JSON.stringify(this.beforeEditingCache);
    },

    canCreateGroup() {
      const isSuperAdmin = this.$store.state.auth.isSuperAdmin;
      const isPolicyAdmin = this.$store.state.auth.isPolicyAdmin;
      return isSuperAdmin || isPolicyAdmin;
    }
  }
};
</script>


<style scoped>
.form-title{
 font-size: 24px;
 font-weight: 400;
 line-height: 30px;
 color: #435666;
}

.high{
   color: #EB1C24;
}

.low{
   color: #00A54F;
}

.medium{
   color: #F3994D;
}

select>option{
  color: #435666;
  font-size:14px !important;
}

form label:not(#compulsoryLbl){
   color: #00A0C1;
   margin: 0.5rem 0;
}

input:not([type="checkbox"]), select {
   height: 40px;
   border-radius: 10px;
   border: 1px solid #D9D9D9;
   color: #435666;
}

/* Style to hide spinner for number input in Bootstrap 5 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.btn.disabled, .btn:disabled, fieldset:disabled .btn {
	color: white;
	pointer-events: none;
	background-color: #435666;
	border-color: #435666;
	opacity: .5;
}

.btn-square {
  border-radius: 0px;
  border: 1px solid #00A0C1;
}

/* policy status tags */
.policy--current {
   background-color: #00A54F;
   color: #fff;
}

.policy--review_required {
  background-color: #F3994D;
  color: #fff;
}

.policy--review_overdue {
background-color: #EB1C24;
color: #fff;
}

.policy-badge {
  width: 147px;
  text-align: center;
  display: inline-block;
  height: 40px;
  font-size: 14px;
  font-weight: 900;
  line-height: 2;
}

.form-control:disabled {
    background-color: #D9D9D9;
}
</style>
